var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"menu-item image",class:_vm._class,style:(_vm._style),attrs:{"to":'/' + _vm._slug,"data-menu-item":_vm.slug}},[_c('div',{staticClass:"has-ratio"},[_c('div',{staticClass:"menu-item-body",class:{ 'has-background': !_vm._nobackground },domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }